module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.0Rc.47 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 修复内容多时的箭头位置 #715 @greedying ")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/qrcode.html"
    }
  }, [_vm._v("Qrcode")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持渲染类型为图片 #900 @keepgoingwm")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 删除无用代码")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复`取消`按钮在非`fixed`情况下没有出现的问题 @excitedcat")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复页面上多个实例时，`label id`冲突")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-727a9444", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-727a9444"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.0-rc.47-203.vue
// module id = 2862
// module chunks = 433